import { render, staticRenderFns } from "./SelfPublishingCreateBook.vue?vue&type=template&id=dcb2b770&scoped=true&"
import script from "./SelfPublishingCreateBook.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingCreateBook.vue?vue&type=script&lang=js&"
import style0 from "./SelfPublishingCreateBook.vue?vue&type=style&index=0&id=dcb2b770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb2b770",
  null
  
)

export default component.exports